module.exports = __webpack_public_path__ + "img/Random_Bule-min.4812df26.png";